// Code review - In Progress
// Documentation - In Progress
import React, { useEffect } from "react";
import { mainTable } from "../css/Common";
import { useState } from "react";
import { countryMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import TableGrid from "../components/Table";
import MainPopup from "../popup-containers/MainPopup";
import Country from "../popup-containers/Country";
const CountryMaster = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);

  const [countryName, setCountryName] = useState("");

  const [countryCode, setCountryCode] = useState("");

  const [countryError, setCountryError] = useState("");

  // const [bindCountryMasterDatas, setbindCountryMasterDatas] = useState({}); // Will be used in functionality
  const [bindCountryMasterDatas, setbindCountryMasterDatas] = useState([
    {
      CountrySno: 1,
      CountryName: "India",
      CountryCode: "IND",
    },
    {
      CountrySno: 2,
      CountryName: "India",
      CountryCode: "IND",
    },
    {
      CountrySno: 3,
      CountryName: "India",
      CountryCode: "IND",
    },
    {
      CountrySno: 4,
      CountryName: "India",
      CountryCode: "IND",
    },
    {
      CountrySno: 5,
      CountryName: "India",
      CountryCode: "IND",
    },
  ]);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [countryData, setCountryData] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteButton, setDeleteButton] = useState(false);
  const [blockButton, setBlockButton] = useState(false);
  const [unBlockButton, setUnBlockButton] = useState(false);

  const [currentPage1, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [result, setResult] = useState(10);
  const [searchValue, setSearchValue] = useState(0);

  function HandleDropDown(e) {}

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  const handleClose = () => {
    setpopUpOpen(false);
    // setPopUpOpenCountry(false);
  };
  const HandleCountry = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteButton(false);
      setBlockButton(false);
      setUnBlockButton(false);
    } else if (flag === 2) {
      setViewDetails(true);
      setDeleteButton(true);
      setBlockButton(false);
      setUnBlockButton(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(true);
      setDeleteButton(false);
      setBlockButton(true);
      setRowIndex(rowIndex);
      setUnBlockButton(false);
    } else if (flag === 4) {
      setViewDetails(true);
      setDeleteButton(false);
      setBlockButton(false);
      setRowIndex(rowIndex);
      setUnBlockButton(true);
    } else if (flag === 6) {
      setViewDetails(true);
      setDeleteButton(false);
      setBlockButton(false);
      setRowIndex(rowIndex);
    }
    setCountryData(bindCountryMasterDatas[rowIndex]);
  };

  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
  };
  // useEffect(() => {
  //   const countryData = async () => {
  //     const response = await countryBindAPI();
  //     setbindCountryMasterDatas(response.data.Table);
  //   };
  //   countryData();
  // }, []);
  const handleSubmit = async (items, flag) => {
    cancel();
    // 
    // setCountryError(
    //   countryName.length > 0
    //     ? /[A-Za-z ]/.exec(countryName)
    //       ? ""
    //       : "Only Alphabet and space allowed"
    //     : "Enter Country Name"
    // );
    // if (!countryError) {
    //   const data = [
    //     {
    //       language: "en",
    //       countryName: countryName,
    //       createdBy: 1,
    //       flag: 1,
    //     },
    //   ];
    //   if (flag == 1) {
    //     const response = await countryInsertAPI(data);
    //     if (response.data.Table[0].Result === "S") {
    //       alert("Inserted");
    //     } else {
    //       alert("Not inserted");
    //     }
    //   }
    // }
  };
  return (
    <MainLayout pageName="2">
      {visibleTable && (
        <div className="max-md:absolute">
          <div className={mainTable.headerTitle}>
            <div className="my-2 mx-12 lg:mx-0">{`Country Master`}</div>
          </div>
          <div className="justify-between flex items-center">
            <div className={mainTable.searchAdd}>
              <div className="mt-1 gap-2 flex justify-between items-baseline">
                <label htmlFor="pageSize" className="hidden md:block">
                  Rows Per Page:
                </label>
                <select
                  onChange={HandleDropDown}
                  className={mainTable.dropDownRecords}
                  name="pageSize"
                >
                  <option value="2">2</option>
                  <option value="5" selected>
                    5
                  </option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div>
                <label htmlFor="table-search" className="sr-only">
                  Search
                </label>
              </div>
              <div className="relative mt-1">
                <div className={mainTable.searchIconPosition}>
                  <svg
                    className={mainTable.searchIconSvg}
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <input
                  type="text"
                  className={mainTable.searchInputBox}
                  placeholder="Search for items"
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
            </div>
            <div className="flex self-end">
              <div className="text-red-600 bg-gray-100 border border-gray-100 rounded-lg shadow-inner w-fit h-9 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 mb-2">
                <span className="mb-12 text-red-600 text-7xl">.</span>
                <span>Block</span>
              </div>
              <button
                type="button"
                className={mainTable.addButton}
                onClick={showadd}
              >
                <svg
                  width="25"
                  height="20"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.5 37.5H27.5V27.5H37.5V22.5H27.5V12.5H22.5V22.5H12.5V27.5H22.5V37.5ZM25 50C21.5417 50 18.2917 49.3433 15.25 48.03C12.2083 46.7183 9.5625 44.9375 7.3125 42.6875C5.0625 40.4375 3.28167 37.7917 1.97 34.75C0.656667 31.7083 0 28.4583 0 25C0 21.5417 0.656667 18.2917 1.97 15.25C3.28167 12.2083 5.0625 9.5625 7.3125 7.3125C9.5625 5.0625 12.2083 3.28083 15.25 1.9675C18.2917 0.655833 21.5417 0 25 0C28.4583 0 31.7083 0.655833 34.75 1.9675C37.7917 3.28083 40.4375 5.0625 42.6875 7.3125C44.9375 9.5625 46.7183 12.2083 48.03 15.25C49.3433 18.2917 50 21.5417 50 25C50 28.4583 49.3433 31.7083 48.03 34.75C46.7183 37.7917 44.9375 40.4375 42.6875 42.6875C40.4375 44.9375 37.7917 46.7183 34.75 48.03C31.7083 49.3433 28.4583 50 25 50ZM25 45C30.5833 45 35.3125 43.0625 39.1875 39.1875C43.0625 35.3125 45 30.5833 45 25C45 19.4167 43.0625 14.6875 39.1875 10.8125C35.3125 6.9375 30.5833 5 25 5C19.4167 5 14.6875 6.9375 10.8125 10.8125C6.9375 14.6875 5 19.4167 5 25C5 30.5833 6.9375 35.3125 10.8125 39.1875C14.6875 43.0625 19.4167 45 25 45Z"
                    fill="white"
                  />
                </svg>
                ADD
              </button>
            </div>
          </div>
          <TableGrid
            className={mainTable.table}
            headerData={countryMasterHeader}
            tableData={bindCountryMasterDatas}
            onViewGrid={HandleCountry}
          />
          <div className={mainTable.submitCancelMainDiv}>
            <button
              disabled={currentPage1 === 1}
              onClick={() => setCurrentPage(currentPage1 - 1)}
              type="button"
              className={mainTable.submitButton}
            >
              Previous
            </button>
            <label>{currentPage1}</label>
            <button
              disabled={currentPage1 === totalPages / result}
              onClick={() => setCurrentPage(currentPage1 + 1)}
              type="button"
              className={mainTable.cancelButton}
            >
              Next
            </button>
          </div>
        </div>
      )}
      {visibleAdd && (
        <div class="w-full ">
          <div class=" border-black  ">
            <div class="text-black text-2xl font-bold mx-8">
              <div class="mt-3 py-4">
                <h3 class="mb-4 text-xl font-medium text-gray-900 ">
                  {`Country Master - Add`}
                </h3>
              </div>
            </div>
          </div>

          <div class="mx-auto w-2/5 border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              {/* <h3 class="mb-4 text-xl font-medium text-gray-900 ">
                  {`Country Master - Add`}
                </h3> */}
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <InputText
                      inputType={"text"}
                      title={"Country"}
                      name={"countryName"}
                      content={countryName}
                      controlFunc={(e) => setCountryName(e.target.value)}
                    />
                    <InputText
                      inputType={"text"}
                      title={"Country Code"}
                      name={"countryName"}
                      content={countryCode}
                      controlFunc={(e) => setCountryCode(e.target.value)}
                    />
                    <div class={mainTable.submitCancelMainDiv}>
                      <button
                        data-modal-hide="bottom-right-modal"
                        type="button"
                        onClick={() => handleSubmit(0, 1)}
                        class={mainTable.submitButton}
                      >
                        SUBMIT
                      </button>
                      <button
                        data-modal-hide="bottom-right-modal"
                        type="button"
                        onClick={cancel}
                        class={mainTable.cancelButton}
                      >
                        CANCEL
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={HandleCountry}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={handleClose}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <Country data={countryData} />
        </div>
        <div class={mainTable.submitCancelMainDiv}>
          {deleteButton && (
            <button
              data-modal-hide="bottom-right-modal"
              type="button"
              class={mainTable.submitButton}
              onClick={() => handleSubmit(rowIndex, 3)}
            >
              Delete
            </button>
          )}

          {blockButton && (
            <button
              data-modal-hide="bottom-right-modal"
              type="button"
              class={mainTable.submitButton}
              onClick={() => handleSubmit(rowIndex, 4)}
            >
              Block
            </button>
          )}
          {unBlockButton && (
            <button
              data-modal-hide="bottom-right-modal"
              type="button"
              class={mainTable.submitButton}
              onClick={() => handleSubmit(rowIndex, 5)}
            >
              Unblock
            </button>
          )}

          <button
            data-modal-hide="bottom-right-modal"
            type="button"
            class={mainTable.cancelButton}
            onClick={cancel}
          >
            CANCEL
          </button>
        </div>
      </MainPopup>
    </MainLayout>
  );
};

export default CountryMaster;
